import VertragsKontoSaldoMixin from "./VertragsKontoSaldoMixin";

// @vue/component
export default {
  name: "VertragsKontoSaldo",
  mixins: [
    VertragsKontoSaldoMixin,
  ],
};
